var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_76843)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000976562 0.00231934H60.0107V45.0023H-0.000976562V0.00231934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57422 13.6702L12.8162 4.31068L14.3761 5.35101L8.13413 14.7105L6.57422 13.6702ZM8.91409 15.2307L15.1561 5.87118L16.716 6.91151L10.474 16.271L8.91409 15.2307ZM11.254 16.7912L17.496 7.43168L19.0559 8.47201L12.8139 17.8315L11.254 16.7912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7732 36.9492L42.9736 31.7476L43.4938 30.9676L51.2934 36.1693L50.7732 36.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6143 16.2727C22.2697 13.7904 24.8435 12.0674 27.7694 11.4828C30.6952 10.8981 33.7335 11.4997 36.2157 13.1552C38.698 14.8107 40.421 17.3845 41.0057 20.3103C41.5903 23.2362 40.9887 26.2744 39.3332 28.7567L20.6143 16.2727Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6141 16.2727C18.9586 18.755 18.357 21.7933 18.9416 24.7191C19.5263 27.645 21.2493 30.2187 23.7316 31.8742C26.2138 33.5297 29.2521 34.1313 32.178 33.5466C35.1038 32.962 37.6776 31.239 39.333 28.7567C40.1608 27.5156 40.4616 25.9964 40.1693 24.5335C39.8769 23.0706 39.0154 21.7837 37.7743 20.956C36.5332 20.1282 35.014 19.8274 33.5511 20.1198C32.0882 20.4121 30.8013 21.2736 29.9736 22.5147L20.6141 16.2727Z",
    fill: "#0047A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9737 22.5147C31.6973 19.9301 30.9995 16.4376 28.4149 14.7139C25.8304 12.9902 22.3378 13.6881 20.6142 16.2726C18.8905 18.8572 19.5884 22.3497 22.1729 24.0734C24.7575 25.7971 28.25 25.0992 29.9737 22.5147Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2705 33.5717L11.9307 35.1322L11.4105 34.3522L13.7504 32.7917L14.2705 33.5717ZM46.2488 12.2449L43.5189 14.0654L42.9988 13.2855L45.7286 11.4649L46.2488 12.2449ZM50.9285 9.12386L48.5887 10.6844L48.0685 9.90441L50.4084 8.3439L50.9285 9.12386Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_76843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.7385e8825192090ed736cfa1271c5902.svg";
export { ForwardRef as ReactComponent };